import { Component } from '@angular/core';

@Component({
  selector: 'cx-store-finder-header',
  templateUrl: './store-finder-header.component.html',
})
export class StoreFinderHeaderComponent {}
